import React, { useState } from 'react';
import api from '../services/api';
import './Login.css';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await api.login(username, password);
      onLogin(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-shell">
        <div className="login-mobile-header">
          <span className="login-mobile-brand">Inventory Control Studio</span>
        </div>

        <div className="login-hero">
          <div className="hero-badge">Multi-Industry Inventory OS</div>
          <h1 className="login-title">
            Control inventory across <span>plants, stores, and teams.</span>
          </h1>
          <p className="login-tagline">
            One workspace for materials, finished goods, and production flow. Built for factories,
            wholesalers, workshops, and retail operations.
          </p>
          <div className="hero-metrics">
            <div className="metric-card">
              <span>Live Stock</span>
              <strong>Every aisle, every shift</strong>
            </div>
            <div className="metric-card">
              <span>Audit Trails</span>
              <strong>Clear movement history</strong>
            </div>
            <div className="metric-card">
              <span>Multi-Company</span>
              <strong>Separation by brand</strong>
            </div>
          </div>
          <div className="hero-industries">
            <span>Textiles</span>
            <span>Manufacturing</span>
            <span>Components</span>
            <span>Retail</span>
            <span>Warehousing</span>
          </div>
          <div className="hero-grid">
            <div>
              <h3>Move faster</h3>
              <p>Quick stock entry with automatic totals and notes.</p>
            </div>
            <div>
              <h3>Stay accurate</h3>
              <p>Threshold indicators keep risks obvious.</p>
            </div>
            <div>
              <h3>Scale safely</h3>
              <p>Role-based access for every location.</p>
            </div>
          </div>
        </div>

        <div className="login-box">
          <div className="login-box-header">
            <h2>Sign in</h2>
            <p>Access your company workspace.</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="admin or admin@company"
                autoComplete="username"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter password"
                autoComplete="current-password"
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" disabled={loading}>
              {loading ? 'Signing in...' : 'Continue'}
            </button>
          </form>
          <div className="login-help">
            <p>
              Use <strong>username@company</strong> to access a specific company.
            </p>
            <p>Need access? Ask your company admin.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
